export default __webpack_public_path__ + "static/media/pdf_news_header.67566b56.png";